<template>
<div v-animate="'slide-up'">
  <slot />
</div>
</template>

<script>
export default {
  name: "Animated"
 }
</script>

<style lang="scss">
.animate {
  opacity: 0;
  transition-delay: .2s;
  transition-duration: .2s;
  transition-timing-function: ease-in-out;
}

.slide-up {
  transform: translateY(100px);
}

.slide-up.animate-active {
  transform: translateY(0);
  opacity: 1;
}
</style>
